var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.category ? _c('form-product', {
    ref: "form-product",
    attrs: {
      "forDraft": "",
      "title": "상품 정보",
      "productInfo": _vm.productInfo,
      "categoryInfo": _vm.categoryInfo,
      "isValid": _vm.isProductValid,
      "isUnitValid": _vm.isUnitValid,
      "isShowError": _vm.showError
    },
    on: {
      "change": _vm.changeFormProduct,
      "selectItem": _vm.handleSelectItem
    }
  }) : _vm._e(), _vm.category ? _c('form-seller', {
    ref: "form-seller",
    attrs: {
      "title": "판매자 정보",
      "sellerInfo": _vm.sellerInfo,
      "isShowError": _vm.showError,
      "isValid": _vm.isSellerValid
    },
    on: {
      "change": _vm.changeFormSeller
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }